var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInviteFriends(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "invite-friends",
    clipPath: "url(#clip0_1171_91274)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 2443"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.89807 6.76685C6.7904 6.76685 7.65795 6.40744 8.29002 5.77537C8.92209 5.1433 9.2815 4.27576 9.2815 3.38342C9.2815 2.49109 8.92209 1.62355 8.29002 0.99148C7.65795 0.359411 6.7904 0 5.89807 0C5.00574 0 4.1382 0.359411 3.50613 0.99148C2.87406 1.62355 2.51465 2.49109 2.51465 3.38342C2.51465 4.27576 2.87406 5.1433 3.50613 5.77537C4.1382 6.40744 5.00574 6.76685 5.89807 6.76685Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.33039 14.6987C7.74403 13.1123 7.63248 10.6212 8.97098 8.88614C8.05386 8.31604 7.00042 7.9938 5.90979 7.9938C4.3606 7.9938 2.87338 8.61348 1.77036 9.70411C0.66734 10.7947 0.0600586 12.282 0.0600586 13.8435V13.9427C0.0600586 14.0418 0.0972391 14.1534 0.146813 14.2401C0.196387 14.3269 0.270748 14.4012 0.357502 14.4632C1.98105 15.4423 3.87726 16 5.90979 16C7.29786 16 8.67354 15.7273 9.95007 15.2068C9.73938 15.0581 9.52869 14.897 9.34279 14.7111L9.33039 14.6987Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M14.9323 9.09682C13.569 7.73353 11.3506 7.73353 9.98731 9.09682C8.62402 10.4601 8.62402 12.6785 9.98731 14.0418C11.3506 15.4051 13.569 15.4051 14.9323 14.0418C16.2956 12.6785 16.2956 10.4601 14.9323 9.09682ZM14.1019 12.1208H13.0113V13.2115C13.0113 13.5213 12.7635 13.7692 12.4536 13.7692C12.1438 13.7692 11.8959 13.5213 11.8959 13.2115V12.1208H10.8053C10.4954 12.1208 10.2476 11.873 10.2476 11.5631C10.2476 11.2533 10.4954 11.0054 10.8053 11.0054H11.8959V9.91479C11.8959 9.60495 12.1438 9.35708 12.4536 9.35708C12.7635 9.35708 13.0113 9.60495 13.0113 9.91479V11.0054H14.1019C14.4118 11.0054 14.6597 11.2533 14.6597 11.5631C14.6597 11.873 14.4118 12.1208 14.1019 12.1208Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1171_91274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteFriends);
export default __webpack_public_path__ + "static/media/InviteFriends.04eb4b945fffce9c7780830c8556249f.svg";
export { ForwardRef as ReactComponent };